import React from 'react';
import { Slider, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectDateRange,
  selectIsClimate,
} from '../../store/options/options.selector';
import { changeDateRange } from '../../store/options/options.slice';
import { updateMapData } from '../../store/data/data.slice';

import './date-slider.styles.scss';

export default function DateSlider() {
  const dateRange = useSelector(selectDateRange);
  const isClimate = useSelector(selectIsClimate);
  const dispatch = useDispatch();

  const handleSlide = (e, newValues) => {
    dispatch(changeDateRange(newValues));
  };

  const handleFinish = () => {
    dispatch(updateMapData({ dateRange, isClimate }));
  };

  return (
    <div className='slider-container'>
      <Typography variant='h5' component='h2' id='date-slider-label'>
        Time Range
      </Typography>
      <Slider
        id='slider'
        min={dateRange.min}
        max={dateRange.max}
        value={[dateRange.start, dateRange.end]}
        valueLabelDisplay='on'
        onChange={handleSlide}
        onChangeCommitted={handleFinish}
      />
    </div>
  );
}
